import { useEffect, useState, useRef } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import Loader from "../addons/Loader";
import "react-photo-view/dist/react-photo-view.css";
import "./OurWork.css";

function OurWork() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [galleryMap, setGalleryMap] = useState({});
  const [galleryLoading, setGalleryLoading] = useState(false);
  const clickRefs = useRef({});

  const POSTS_PER_PAGE = 8;

  useEffect(() => {
    setLoading(true);
    fetch(
      `https://fedev.fues.hr/backend/wp-json/wp/v2/posts?_embed&categories=7&per_page=${POSTS_PER_PAGE}&page=${currentPage}`
    )
      .then((response) => {
        const total = response.headers.get("X-WP-TotalPages");
        setTotalPages(Number(total));
        return response.json();
      })
      .then((data) => {
        setPosts(data);
        setTimeout(() => setLoading(false), 1000);
      });
  }, [currentPage]);

  const extractGalleryImages = (html) => {
    const matches = [...html.matchAll(/<img[^>]+src="([^">]+)"/g)];
    return matches.map((m) => m[1]);
  };

  const openGallery = async (post) => {
    if (galleryMap[post.id]) {
      clickRefs.current[post.id]?.click();
      return;
    }

    setGalleryLoading(true);
    const res = await fetch(
      `https://fedev.fues.hr/backend/wp-json/wp/v2/posts/${post.id}`
    );
    const data = await res.json();
    const galleryImages = extractGalleryImages(data.content.rendered);
    setGalleryMap((prev) => ({ ...prev, [post.id]: galleryImages }));
    setGalleryLoading(false);

    setTimeout(() => {
      clickRefs.current[post.id]?.click();
    }, 100);
  };

  const handlePrev = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const handleNext = () => setCurrentPage((p) => Math.min(p + 1, totalPages));

  return (
    <main className="relative my-5">
      <div className="container">
        <h1>Naši radovi</h1>
        {galleryLoading && (
          <div className="gallery-overlay-loader">
            <Loader />
          </div>
        )}

        <div className="row g-4">
          {!loading ? (
            posts.map((post) => {
              const featuredImage =
                post?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes
                  ?.medium?.source_url;
              const power = post?._embedded?.["wp:term"]?.find(
                (group) => group?.[0]?.taxonomy === "power"
              )?.[0]?.name;

              const gallery = galleryMap[post.id];

              return (
                <div key={post.id} className="col-md-3">
                  <article className="d-flex flex-column workCard">
                    <PhotoProvider
                      maskOpacity={0.3}
                      overlayRender={() => (
                        <div className="backdrop-blur-sm fixed inset-0 z-40" />
                      )}
                    >
                      <img
                        src={featuredImage}
                        alt={post.title.rendered}
                        style={{ cursor: "pointer" }}
                        onClick={() => openGallery(post)}
                      />

                      {gallery &&
                        gallery.map((img, i) => (
                          <PhotoView key={i} src={img}>
                            <div
                              ref={(el) => {
                                if (i === 1) clickRefs.current[post.id] = el;
                              }}
                              style={{ display: "none" }}
                            />
                          </PhotoView>
                        ))}
                    </PhotoProvider>

                    <div className="py-2 px-3">
                      <h3>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#009CD1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin-house-icon lucide-map-pin-house"
                        >
                          <path d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z" />
                          <path d="M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2" />
                          <path d="M18 22v-3" />
                          <circle cx="10" cy="10" r="3" />
                        </svg>{" "}
                        {post.title.rendered}
                      </h3>
                      <p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#48C353"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-house-plug-icon lucide-house-plug"
                        >
                          <path d="M10 12V8.964" />
                          <path d="M14 12V8.964" />
                          <path d="M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z" />
                          <path d="M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2" />
                        </svg>{" "}
                        <span className="power">
                          {power.length > 1
                            ? `${power.slice(0, -1)}${power
                                .slice(-1)
                                .toUpperCase()}`
                            : power.toUpperCase()}
                        </span>
                      </p>
                    </div>
                  </article>
                </div>
              );
            })
          ) : (
            <div className="container loading">
              <Loader />
            </div>
          )}
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className="cta cta-page"
          >
            Prethodna
          </button>
          <span className="page-info">
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="cta cta-page"
          >
            Sljedeća
          </button>
        </div>
      </div>
    </main>
  );
}

export default OurWork;
